import { FormattedMessage } from "react-intl";
import { SpotlightsForLensGrid } from "../SpotlightsForLens";
import { MoreLensesGrid } from "../MoreLenses";
import styles from "./MoreContentOptions.module.css";
export default function getTabs(size, spotlightsUsingThisLens, lensName, moreLenses) {
    return [
        {
            label: (<FormattedMessage description="Title of the spotlight videos section for a given lens" defaultMessage="Spotlight Snaps"/>),
            content: () => (<div className={styles.spotlightForLensTabContainer}>
          <SpotlightsForLensGrid spotlights={spotlightsUsingThisLens} lensName={lensName} size={size}/>
        </div>),
        },
        {
            label: (<FormattedMessage description="Title of the more lenses section for a given lens" defaultMessage="More Lenses"/>),
            content: () => (<div className={styles.spotlightForLensTabContainer}>
          <MoreLensesGrid lenses={moreLenses} size={size}/>
        </div>),
        },
    ];
}
